import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function money(value) {
  return Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function safeFileName(value) {
  return String(value || "")
    .trim()
    .replace(/[^\w-]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function fullName(row) {
  return (
    `${row.first_name || ""} ${row.last_name || ""}`.trim() ||
    row.employee_name ||
    "-"
  );
}

export function exportPayrollEmployeesPDF({
  company,
  employees = [],
  title = "Payroll Employees List",
}) {
  const doc = new jsPDF("landscape");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const brandTeal = [0, 128, 128];
  const brandGold = [237, 179, 45];
  const dark = [51, 51, 51];
  const muted = [95, 111, 111];

  doc.setFillColor(...brandTeal);
  doc.rect(0, 0, pageWidth, 30, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(255, 255, 255);
  doc.text(company?.company_name || "KostPadi Company", 14, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(title, 14, 22);

  doc.setFillColor(...brandGold);
  doc.rect(14, 36, pageWidth - 28, 3, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...muted);
  doc.text(`Total Employees: ${employees.length}`, 14, 48);

  const rows = employees.map((row, index) => [
    String(index + 1),
    row.employee_code || "-",
    fullName(row),
    row.department || "-",
    row.job_title || "-",
    row.job_level_name || "-",
    row.job_grade_name || "-",
    row.employment_type || "-",
    row.employment_status || "-",
    row.salary_basis || "-",
    money(row.base_salary || 0),
    row.bank_name || "-",
    row.bank_account_name || "-",
    row.bank_account_number || "-",
  ]);

  if (!rows.length) {
    rows.push([
      "1",
      "-",
      "No employees found",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "-",
      "0.00",
      "-",
      "-",
      "-",
    ]);
  }

  autoTable(doc, {
    startY: 54,
    margin: { left: 10, right: 10 },
    head: [
      [
        "#",
        "Code",
        "Employee",
        "Department",
        "Job Title",
        "Level",
        "Grade",
        "Type",
        "Status",
        "Salary Basis",
        "Base Salary",
        "Bank",
        "Account Name",
        "Account Number",
      ],
    ],
    body: rows,
    theme: "grid",
    styles: {
      fontSize: 5.5,
      textColor: dark,
      cellPadding: 2.5,
      lineColor: [230, 240, 240],
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: brandTeal,
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 8 },
      1: { cellWidth: 18 },
      2: { cellWidth: 32 },
      3: { cellWidth: 24 },
      4: { cellWidth: 28 },
      5: { cellWidth: 18 },
      6: { cellWidth: 18 },
      7: { cellWidth: 16 },
      8: { cellWidth: 16 },
      9: { cellWidth: 18 },
      10: { cellWidth: 20, halign: "right" },
      11: { cellWidth: 26 },
      12: { cellWidth: 30 },
      13: { cellWidth: 26 },
    },
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...muted);
  doc.text(
    company?.address || "Generated from KostPadi Payroll",
    10,
    pageHeight - 10
  );

  doc.save(
    `${safeFileName(company?.company_name || "Company")}_Employees_List.pdf`
  );
}
